// Estima a sequência de dias seguidos de estudo a partir das sessões do
// Diário de Estudos. Sem essa fonte, a única data disponível seria a de
// simulados concluídos, que não representa "dias estudando" de fato.
export function calculateStudyStreak(sessions) {
  if (!sessions || sessions.length === 0) return 0;

  const startOfToday = new Date();
  startOfToday.setHours(0, 0, 0, 0);

  // Sessões com data futura (relógio do dispositivo errado, fuso, ou o campo de
  // data do Diário de Estudos preenchido errado) não podem "ancorar" a sequência
  // lá na frente e mascarar um buraco real mais perto de hoje — ignoramos tudo
  // que for depois de hoje antes de calcular.
  const uniqueDates = [...new Set(sessions.map((session) => String(session.studied_at).slice(0, 10)))]
    .map((dateStr) => new Date(`${dateStr}T00:00:00`))
    .filter((date) => date.getTime() <= startOfToday.getTime())
    .sort((a, b) => b - a);

  if (uniqueDates.length === 0) return 0;

  const msPerDay = 1000 * 60 * 60 * 24;
  const daysSinceMostRecent = Math.round((startOfToday - uniqueDates[0]) / msPerDay);

  // Sequência quebrada: a última sessão não foi nem hoje, nem ontem.
  if (daysSinceMostRecent > 1) return 0;

  let streak = 1;
  for (let i = 1; i < uniqueDates.length; i++) {
    const diff = Math.round((uniqueDates[i - 1] - uniqueDates[i]) / msPerDay);
    if (diff === 1) {
      streak++;
    } else {
      break;
    }
  }
  return streak;
}

const WEEK_DAY_LABELS = ['S', 'T', 'Q', 'Q', 'S', 'S', 'D']; // Seg Ter Qua Qui Sex Sáb Dom

// Formata em YYYY-MM-DD usando os componentes locais (evita o shift de dia que
// Date.toISOString() causaria em fusos com offset positivo em relação ao UTC).
function toLocalDateStr(date) {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

// Retorna os 7 dias da semana atual (segunda a domingo), marcando quais tiveram
// sessão registrada no Diário de Estudos e qual é "hoje" — para o card "Sua
// sequência" (ver studyStreak, que já calcula o número de dias seguidos).
export function getWeekStudyDays(sessions) {
  const studiedDates = new Set(
    (sessions || []).map((session) => String(session.studied_at).slice(0, 10))
  );

  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const mondayOffset = (today.getDay() + 6) % 7; // getDay(): 0=dom..6=sáb -> distância até a segunda
  const monday = new Date(today);
  monday.setDate(monday.getDate() - mondayOffset);

  return WEEK_DAY_LABELS.map((label, i) => {
    const day = new Date(monday);
    day.setDate(monday.getDate() + i);
    const dateStr = toLocalDateStr(day);
    return {
      key: dateStr,
      label,
      studied: studiedDates.has(dateStr),
      isToday: day.getTime() === today.getTime()
    };
  });
}
